import { render, staticRenderFns } from "./exercise.medium.vue?vue&type=template&id=3f90a13d&scoped=true&"
import script from "./exercise.medium.vue?vue&type=script&lang=js&"
export * from "./exercise.medium.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f90a13d",
  null
  
)

export default component.exports